import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import {
  GetBaladaAppResponse,
  GetBaladaAppByIdResponse,
  PostBaladaAppResponse,
  PutBaladaAppResponse,
} from '../response/balada-app';
import { PostBaladaAppRequest, PutBaladaAppRequest } from '../request/balada-app';

export class BaladaAppService {
  static getBaladaApps(params?: QueryParams) {
    return apiClient.get<GetBaladaAppResponse>(buildApiUrl('/api/v1/partners/balada-app'), params);
  }

  static getBaladaAppByUUID(uuid: string) {
    const url = buildApiUrl('/api/v1/partners/balada-app/:uuid', { uuid });
    return apiClient.get<GetBaladaAppByIdResponse>(url, undefined);
  }

  static postBaladaApp(data: PostBaladaAppRequest) {
    return apiClient.createWithFile<PostBaladaAppResponse>(
      buildApiUrl('/api/v1/partners/balada-app'),
      data,
    );
  }

  static putBaladaApp(uuid: string, data: PutBaladaAppRequest) {
    const url = buildApiUrl('/api/v1/partners/balada-app/:uuid', { uuid });
    return apiClient.updateWithFile<PutBaladaAppResponse>(url, data);
  }

  static deleteBaladaApp(uuid: string) {
    const url = buildApiUrl('/api/v1/partners/balada-app/:uuid', { uuid });
    return apiClient.delete<void>(url, undefined);
  }
}
